import React from "react";
import { Title, Container } from "@mantine/core";
import { useLocation, Navigate } from "react-router-dom";

import UseStyles from "./useStyles";

import { isAuthenticated } from "services/auth";

export default function Unauthorized() {
  const { classes } = UseStyles();

  const location = useLocation();

  return isAuthenticated() === true ? (
    <Navigate to="/" state={{ from: location }} replace />
  ) : (
    <>
      <Container className={classes.root}>
        <div className={classes.label}>401</div>
        <Title className={classes.title}>Authorization Required</Title>
      </Container>
    </>
  );
}
